var map = {
	"./19.JPG": 201,
	"./20210501_091914726_iOS.jpg": 202,
	"./22.jpg": 203,
	"./Close-1.JPG": 204,
	"./CloseUp2.jpeg": 205,
	"./IMG-20230508-WA0172.jpg": 206,
	"./IMG-20230508-WA0173.jpg": 207,
	"./IMG-20230508-WA0175.jpg": 208,
	"./IMG-20230508-WA0176.jpg": 209,
	"./IMG-20230508-WA0177.jpg": 210,
	"./IMG-20230508-WA0178.jpg": 211,
	"./Veg.png": 212,
	"./WhatsApp Image 2021-02-23 at 22.46.54.jpeg": 213,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (17).jpeg": 214,
	"./_23.jpg": 215,
	"./event-3.jpg": 216,
	"./event-6.JPG": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;